import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import LandingNavbar from '../components/LandingNavbar';
import LandingFooter from '../components/LandingFooter';
import AppPreview from '../components/AppPreview';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Helmet>
        <title>Hisab OK Hai - Roz ka kharcha, udhari aur budget tracker</title>
        <meta name="description" content="Hisab OK Hai - India ka apna expense tracker. Roz ka kharcha, udhari, budget aur vendor tracking — sab ek jagah, bina tension. Free mein shuru karein." />
        <meta name="keywords" content="expense tracker india, udhari management, budget planner, kharcha tracker, daily expense tracker, hisab kitab app" />
        <link rel="canonical" href="https://hisabokhai.in/" />
      </Helmet>

      <LandingNavbar />

      {/* Hero */}
      <section className="landing-hero">
        <div className="landing-hero-inner">
          <div className="landing-hero-badge">India ka apna finance app</div>
          <h1>
            Roz ka kharcha, udhari aur budget<br />
            <span>— sab ek jagah, bina tension</span>
          </h1>
          <p className="landing-hero-sub">
            Simple expense tracking, udhari management, budget planning aur reminders — sab kuch ek app mein. Koi confusion nahi, koi tension nahi.
          </p>
          <div className="landing-hero-ctas">
            <Link to="/signup" className="cta-primary">Free Start Karein</Link>
            <Link to="/login" className="cta-secondary">Login</Link>
          </div>
        </div>
      </section>

      {/* Trust Boosters */}
      <section className="landing-trust-strip">
        <div className="landing-trust-strip-inner">
          <div className="trust-strip-item">
            <span className="trust-strip-check">&#10003;</span>
            <span>Free plan available</span>
          </div>
          <div className="trust-strip-item">
            <span className="trust-strip-check">&#10003;</span>
            <span>2 min setup</span>
          </div>
          <div className="trust-strip-item">
            <span className="trust-strip-check">&#10003;</span>
            <span>Hindi-friendly</span>
          </div>
          <div className="trust-strip-item">
            <span className="trust-strip-check">&#10003;</span>
            <span>Secure &amp; private</span>
          </div>
        </div>
      </section>

      {/* Problem */}
      <section className="landing-section">
        <div className="landing-section-inner">
          <h2>Yeh problems toh sabki hain...</h2>
          <p className="section-sub">Paison ka hisab rakhna mushkil lagta hai, lekin ab nahi.</p>
          <div className="problem-grid">
            <div className="problem-card">
              <div className="problem-icon">&#128176;</div>
              <h3>Kharcha track nahi hota</h3>
              <p>Din bhar mein kahan kitna kharcha hua, mahine ke end mein pata nahi chalta. Paisa kahan gaya — mystery ban jaata hai.</p>
            </div>
            <div className="problem-card">
              <div className="problem-icon">&#128221;</div>
              <h3>Udhari bhool jaate hain</h3>
              <p>Kisne kitna diya, kisne liya — diary mein likha tha par diary kho gayi. Udhari ka hisab bigad jaata hai aur rishte kharab hote hain.</p>
            </div>
            <div className="problem-card">
              <div className="problem-icon">&#128200;</div>
              <h3>Budget banta hi nahi</h3>
              <p>Mahine ki planning karni thi par expenses ka data hi nahi hai. Bina tracking ke budget banana impossible hai.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Solution */}
      <div className="landing-section-alt">
        <section className="landing-section">
          <div className="landing-section-inner">
            <h2>Hisab OK Hai se sab solve hoga</h2>
            <p className="section-sub">Simple, fast aur reliable — aapka apna finance assistant.</p>
            <div className="solution-grid">
              <div className="solution-card">
                <div className="solution-icon">&#9997;&#65039;</div>
                <h3>Simple entry, instant tracking</h3>
                <p>Ek click mein kharcha add karo. Amount, category, date — bas. Baaki sab app sambhal lega.</p>
              </div>
              <div className="solution-card">
                <div className="solution-icon">&#128276;</div>
                <h3>Reminders jo bhoolne na dein</h3>
                <p>Udhari wapas leni hai? Bill pay karna hai? Reminder set karo, app yaad dilayega.</p>
              </div>
              <div className="solution-card">
                <div className="solution-icon">&#128202;</div>
                <h3>Reports jo sab dikhayen</h3>
                <p>Daily, monthly, yearly — har tarah ki reports. Category-wise breakdown se pata chalega paisa kahan ja raha hai.</p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* App Preview */}
      <section className="landing-section" id="app-preview">
        <div className="landing-section-inner">
          <h2>App Preview — Dekho kaise kaam karta hai</h2>
          <p className="section-sub">Real app ka interface — simple, clean aur powerful.</p>
          <AppPreview />
        </div>
      </section>

      {/* Features */}
      <div className="landing-section-alt" id="features">
        <section className="landing-section">
          <div className="landing-section-inner">
            <h2>Features jo kaam ki cheez hain</h2>
            <p className="section-sub">Bas wohi features jo aapko chahiye — no fluff, only useful.</p>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">&#128210;</div>
                <h3>Multiple Ledgers</h3>
                <p>Ghar ka, dukaan ka, personal — alag alag ledger banao aur sab organize rakho.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">&#128178;</div>
                <h3>Income &amp; Expense</h3>
                <p>Aaya aur gaya — dono track karo. Har transaction ka complete record rakho.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">&#127991;&#65039;</div>
                <h3>Smart Categories</h3>
                <p>Food, rent, travel, shopping — built-in categories plus apni custom categories banao.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">&#128181;</div>
                <h3>Budget Alerts</h3>
                <p>Category-wise budget set karo. Limit cross hone se pehle alert mil jayega.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">&#128257;</div>
                <h3>Recurring Expenses</h3>
                <p>Rent, EMI, subscription — ek baar set karo, har mahine automatic track hoga.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">&#128101;</div>
                <h3>Vendor Tracking</h3>
                <p>Kirana wala, dhobi, electrician — vendor-wise hisab rakho. Kaun kitna lena-dena hai, clear dikhega.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">&#128202;</div>
                <h3>Detailed Reports</h3>
                <p>Charts aur graphs ke saath samjho ki paisa kahan ja raha hai. Smart decisions lo.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">&#128499;&#65039;</div>
                <h3>Receipt Upload</h3>
                <p>Bill ka photo attach karo transaction ke saath. Proof hamesha saath rahega.</p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* How It Works */}
      <section className="landing-section">
        <div className="landing-section-inner">
          <h2>Kaise kaam karta hai?</h2>
          <p className="section-sub">Sirf 3 steps mein shuru ho jao.</p>
          <div className="steps-container">
            <div className="step-card">
              <div className="step-number">1</div>
              <h3>Account Banao</h3>
              <p>Free mein signup karo. Sirf name, email aur password — 30 second mein ready.</p>
            </div>
            <div className="step-connector"></div>
            <div className="step-card">
              <div className="step-number">2</div>
              <h3>Kharcha Add Karo</h3>
              <p>Daily expenses, income, udhari — jo bhi ho, turant add karo. Simple form, no confusion.</p>
            </div>
            <div className="step-connector"></div>
            <div className="step-card">
              <div className="step-number">3</div>
              <h3>Report Dekho</h3>
              <p>Dashboard pe sab dikhega — kitna aaya, kitna gaya, kahan gaya. Full clarity.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Trust & Security */}
      <div className="landing-section-alt">
        <section className="landing-section">
          <div className="landing-section-inner">
            <h2>Aapka data, aapki security</h2>
            <p className="section-sub">Hum security ko seriously lete hain.</p>
            <div className="trust-grid">
              <div className="trust-card">
                <div className="trust-icon">&#128274;</div>
                <h3>Secure Authentication</h3>
                <p>JWT tokens + refresh tokens + 2FA support. Aapka account puri tarah safe hai.</p>
              </div>
              <div className="trust-card">
                <div className="trust-icon">&#128737;&#65039;</div>
                <h3>Data Isolation</h3>
                <p>Har user ka data alag rakha jaata hai. Koi doosra aapka data nahi dekh sakta.</p>
              </div>
              <div className="trust-card">
                <div className="trust-icon">&#9889;</div>
                <h3>Modern Backend</h3>
                <p>PostgreSQL database, Node.js server, Vercel hosting — fast, reliable aur scalable.</p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Explore More - Internal Linking */}
      <section className="landing-section">
        <div className="landing-section-inner">
          <h2>Explore More</h2>
          <p className="section-sub">Jaanein kaise Hisab OK Hai aapke har finance need ko cover karta hai.</p>
          <div className="explore-grid">
            <Link to="/expense-tracker-india" className="explore-card">
              <div className="explore-icon">&#128176;</div>
              <h3>Expense Tracker India</h3>
              <p>India ka best free expense tracker — daily kharcha track karo easily.</p>
              <span className="explore-link">Learn more &rarr;</span>
            </Link>
            <Link to="/udhari-management-app" className="explore-card">
              <div className="explore-icon">&#128221;</div>
              <h3>Udhari Management</h3>
              <p>Lena-dena ka complete hisab — vendor-wise tracking with reminders.</p>
              <span className="explore-link">Learn more &rarr;</span>
            </Link>
            <Link to="/daily-expense-tracker" className="explore-card">
              <div className="explore-icon">&#128197;</div>
              <h3>Daily Expense Tracker</h3>
              <p>Roz ka kharcha record karo aur mahine ke end mein paiso ka hisab rakho.</p>
              <span className="explore-link">Learn more &rarr;</span>
            </Link>
            <Link to="/budget-planner-india" className="explore-card">
              <div className="explore-icon">&#128200;</div>
              <h3>Budget Planner</h3>
              <p>Category-wise budget banao, alerts pao, spending control mein rakho.</p>
              <span className="explore-link">Learn more &rarr;</span>
            </Link>
          </div>
        </div>
      </section>

      {/* Mobile App */}
      <section className="landing-section">
        <div className="landing-section-inner">
          <div className="mobile-section">
            <div className="mobile-section-badge">COMING SOON</div>
            <h2>Android App Coming Soon</h2>
            <p>Jaldi hi aapke phone pe bhi milega Hisab OK Hai. Native Android app ke saath kharcha tracking aur bhi easy hoga.</p>
            <div className="mobile-badge">Coming Soon on Google Play</div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="landing-final-cta">
        <div className="landing-final-cta-inner">
          <h2>Abhi start karein — Free hai!</h2>
          <p>Koi credit card nahi chahiye. Signup karo aur turant use karo.</p>
          <div className="landing-final-cta-buttons">
            <Link to="/signup" className="cta-primary">Abhi Start Karein</Link>
            <Link to="/login" className="cta-secondary cta-secondary--light">Already have account? Login</Link>
          </div>
        </div>
      </section>

      <LandingFooter />
    </div>
  );
};

export default LandingPage;
